<div class="filters-wrapper">
  <div class="filter-container">
    <div class="row g-3 align-items-end">
      <!-- Date Range Section with Get Campaigns Button campaign active during'-->
      <div class="col-xxl-6 col-xl-12">
        <div class="date-button-container">
          <div class="date-range-wrapper">
            <app-month-range
              #monthRange
              [label]="'Campaign Active During'"
              (dateRangeChanged)="onDateRangeChanged($event)"
              (validationStateChanged)="onDateRangeValidationChanged($event)"
              [(fromDate)]="fromDate"
              [(toDate)]="toDate">
            </app-month-range>
          </div>           
        </div>
      </div>
      
      <!-- Campaign Dropdown -->
      <div class="col-xxl-2 col-xl-6 col-lg-6">
        <div class="form-group">
          <label class="form-label text-muted mb-1">Select Campaign</label>
          <div class="dropdown enhanced-dropdown">
            <button 
              class="btn btn-outline-secondary dropdown-toggle" 
              type="button" 
              id="campaignDropdown" 
              data-bs-toggle="dropdown" 
              aria-expanded="false"
              [disabled]="campaigns.length === 0 && !campaignsLoading"
              [title]="selectedCampaignCode || 'Select Campaign'"
            >
              <span>{{ selectedCampaignCode || 'Select Campaign' }}</span>
            </button>
            
            <div class="dropdown-menu" aria-labelledby="campaignDropdown">
              <div class="search-container">
                <input 
                  type="text" 
                  class="form-control form-control-sm" 
                  placeholder="Search campaigns..." 
                  [(ngModel)]="campaignSearch"
                  (click)="$event.stopPropagation()">
                <button *ngIf="campaignSearch" class="clear-btn" (click)="clearCampaignSearch(); $event.stopPropagation()">
                  <i class="bi bi-x"></i>
                </button>
              </div>
              <div class="dropdown-divider search-divider"></div>
              <div class="scrollable-menu">
                <!-- Loading state (inside dropdown, like article/journal filters) -->
                <div *ngIf="campaignsLoading" class="no-results">
                  <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Loading campaigns...
                </div>

                <ng-container *ngIf="!campaignsLoading">
                  <!-- All Campaigns Option (conditional) -->
                  <a *ngIf="showAllCampaignsOption" 
                     class="dropdown-item" 
                     href="#" 
                     (click)="selectCampaign('All Campaigns', $event)"
                     [class.active]="selectedCampaignCode === 'All Campaigns'"
                  >
                    <span class="text-truncate d-block"><strong>All Campaigns</strong></span>
                  </a>
                  <div *ngIf="campaigns.length > 0 && showAllCampaignsOption" class="dropdown-divider"></div>
                  
                  <!-- Individual Campaigns -->
                  <a *ngFor="let campaign of filteredCampaigns" 
                     class="dropdown-item" 
                     href="#" 
                     (click)="selectCampaign(campaign.id, $event)"
                     [title]="campaign.id"
                     [class.active]="selectedCampaignCode === campaign.id"
                  >
                    <span class="text-truncate d-block">{{ campaign.id }}</span>
                  </a>
                  <div *ngIf="filteredCampaigns.length === 0 && campaigns.length > 0" class="no-results">
                    No campaigns found
                  </div>
                  <div *ngIf="campaigns.length === 0" class="no-results">
                    No campaigns available
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Get Performance + Reset -->
      <div class="col-xxl-4 col-xl-6 col-lg-6">
        <div class="campaign-action-buttons d-flex align-items-end gap-2 flex-nowrap">
          <button
            type="button"
            class="btn btn-primary action-btn"
            (click)="getCampaignPerformance()"
            [disabled]="!selectedCampaignCode"
          >
            Get Performance
          </button>
          <button
            type="button"
            class="btn btn-outline-secondary campaign-filter-reset"
            (click)="resetCampaignFilters()"
          >
            Reset
          </button>
        </div>
      </div>
    </div>
    
    <!-- Toast Notification -->
    <app-toast-notification
      *ngIf="toastVisible"
      [type]="toastType"
      [title]="toastTitle"
      [message]="toastMessage"
      (closed)="onToastClosed()"
    ></app-toast-notification>
  </div>
</div> 